window.Products.Clothing.LooseTankTopLong = function() {};

window.Products.Clothing.LooseTankTopLong.inherits(window.Products.Clothing.LooseTankTop);
window.Products.Clothing.LooseTankTopLong.has_3d = true;
window.Products.Clothing.LooseTankTopLong.id = '64-long';
window.Products.Clothing.LooseTankTopLong.saveId = 64;
window.Products.Clothing.LooseTankTopLong.slug = 'loose-tank-top-long';
window.Products.Clothing.LooseTankTopLong.dpi = 150;